export default __webpack_public_path__ + "static/media/Warherald Girdle.188196a7.jpg";